import './vaadin-button-styles.js';
import '../../src/vaadin-button.js';
